/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {CalendarMonthOutlined, PointOfSaleOutlined} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Reserva_Descuento = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={12}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoFecha Icono={CalendarMonthOutlined} editable={false} nombre={'Fecha'} prevenir={true}
                                  dato={'fecha'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Descuento'} dato={'valor'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={3} nombre={'Detalle del Item'}
                                   dato={'descripcion'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Descuento